import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';

import { makeGetExternalAccountByProvider } from '../selectors/external-accounts';

import { externalLoad } from '../api/files-api';
import { createAlert } from '../services/alert-service';
import { openPicker } from '../services/google-service';
import { openElectronHelperBrowser } from '../services/electron-service';
import { openWindow } from '../utils';
import { isElectron } from 'services/env-service';
import { getAccountToken } from '../api/external-accounts-api';

import Tooltip from './tooltip';

class GoogleFileChooser extends PureComponent {
    static defaultProps = {
        type: 'all'
    };

    handleClick = async () => {
        if (!this.props.account) {
            this.props.history.push({
                pathname: `/settings/apps`,
                state: {
                    closeUrl: this.props.location.pathname
                }
            });
            return;
        }

        if (this.opening) {
            return;
        }

        const { token } = await getAccountToken('google', !this.props.account.team);

        if (isElectron()) {
            this.electronChooser(token);
        } else {
            openPicker(token, this.props.type).then(({ files, token }) => {
                this.handleChoose(files, token);
            });
        }


        this.opening = true;
        setTimeout(() => {
            this.opening = false;
        }, 4000);
    }

    electronChooser(googleAuthToken) {
        this.electronBrowserDestroy = openElectronHelperBrowser({
            params: {
                type: 'GOOGLE_PICKER',
                authToken: googleAuthToken,
                pickerType: this.props.type
            },
            windowProps: {
                width: Math.min(window.innerWidth - 100, 1060),
                height: Math.min(window.innerHeight - 100, 650)
            },
            onMessage: messageData => {
                const { action, payload } = messageData;

                if (messageData.action === 'GOOGLE_PICKER_SELECT') {
                    const { files, token } = payload;
                    this.handleChoose(files, token);

                    this.electronBrowserDestroy();
                }
            }
        });
    }

    handleChoose = (files, token) => {
        const { t } = this.props;
        if (this.props.onChange) {
            this.props.onChange(files.map(file => ({
                ...file,
                serviceType: 'google',
                serviceProps: {
                    type: 'google',
                    id: file.id,
                    access_token: token
                }
            })));
            return;
        }

        let alertText;

        if (files.length === 1) {
            alertText = (
                <React.Fragment>
                    <i className="icon material-icons icon-animate-rotate">autorenew</i> { t('Importing file', { file: files[0].name }) }
                </React.Fragment>
            );
        } else {
            alertText = (
                <React.Fragment>
                    <i className="icon material-icons icon-animate-rotate">autorenew</i> { t('Importing files', { count: files.length }) }
                </React.Fragment>
            );
        }

        const alert = createAlert('success', alertText, {
            duration: 0
        });

        externalLoad({
            project: this.props.projectId,
            task: this.props.taskId,
            doc: this.props.docId,
            folder_id: this.props.folderId,
            folder_stack: this.props.folderStack,
            files: files.map(({ id }) => ({
                id,
                access_token: token,
                type: 'google'
            }))
        }).then(response => {
            alert.setContent(
                <React.Fragment>
                    <i className="icon material-icons icon-animate-rotate">autorenew</i> { t('Files imported', { count: files.length }) }
                </React.Fragment>
            );
            alert.hide(5000);
        });
    }

    componentWillUnmount() {
        this.electronBrowserDestroy && this.electronBrowserDestroy();
    }

    render() {
        const { t } = this.props;

        return (
            <Tooltip disabled={this.props.disableAccountTooltip || Boolean(this.props.account)} tooltip={ t('apps:accounts.google.link') }>
                <div onClick={this.handleClick}>
                    { this.props.children }
                </div>
            </Tooltip>
        )
    }
}

const makeMapStateToProps = () => {
    const getExternalAccountTeamByProvider = makeGetExternalAccountByProvider();
    const getExternalAccountUserByProvider = makeGetExternalAccountByProvider();

    return ({ externalAccounts }, ownProps) => {
        const teamAccount = getExternalAccountTeamByProvider(externalAccounts.items, 'google', true);
        const userAccount = getExternalAccountUserByProvider(externalAccounts.items, 'google');

        return {
            account: teamAccount || userAccount
        }
    };
}

export default withRouter(connect(makeMapStateToProps)(withTranslation(['file', 'apps'])(GoogleFileChooser)));
